// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/CompletedJobDetailed.scss
// module id = ./src/styles/CompletedJobDetailed.scss
// module chunks = 0